// mutations
const ACADEMIC_BLOCK_PRODUCTS = (state, academicBlockProducts) => {
    if (academicBlockProducts.code === 1) {
      state.academicBlockProducts = academicBlockProducts.data
      state.status = 'success'
    } else {
      alert(academicBlockProducts.message)
      state.status = 'error'
    }
  }
  
  export default {
    ACADEMIC_BLOCK_PRODUCTS
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/academic/block_products/mutations.js